module.exports = __webpack_public_path__ + "static/media/solis.a375d0c2.png";